import { Box } from "@mui/material";
import {
  type GridToolbarProps,
  Toolbar,
  type ToolbarPropsOverrides,
} from "@mui/x-data-grid-premium";
import React from "react";
import DatagridQuickFilter from "./DatagridQuickFilter";
import ToolbarColumnsButton from "./ToolbarColumnsButton.tsx";
import ToolbarExportButton from "./ToolbarExportButton.tsx";
import ToolbarFilterButton from "./ToolbarFilterButton.tsx";
import "./ToolbarPropsOverrides";
import ToolbarViewMenu from "./ToolbarViewMenu.tsx";

export function BaseTableToolbar({
  showColumns = true,
  showFilter = true,
  showQuickFilter = false,
  showExportCsv = false,
  showViewMenu = true,
  tableId,
  quickFilterColumns = "",
  quickFilterTextFieldTooltip = "",
  customElements,
  onViewStateReady,
  ...toolbarProps
}: ToolbarPropsOverrides & GridToolbarProps) {
  return (
    <Toolbar
      style={{ justifyContent: "start", flexWrap: "wrap", minHeight: "auto" }}
    >
      {showViewMenu && (
        <ToolbarViewMenu
          tableId={tableId}
          onViewStateReady={onViewStateReady}
        />
      )}
      {showColumns && <ToolbarColumnsButton />}
      {showFilter && <ToolbarFilterButton />}
      {showExportCsv && (
        <ToolbarExportButton csvOptions={toolbarProps.csvOptions} />
      )}
      {customElements}
      <Box sx={{ flexGrow: 1 }} />
      {showQuickFilter && (
        <DatagridQuickFilter
          searchColumns={quickFilterColumns ?? ""}
          quickSearchTextFieldToolTip={quickFilterTextFieldTooltip ?? ""}
        />
      )}
    </Toolbar>
  );
}
